<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M18.7882 18.7882C20.5886 16.9879 21.6 14.5461 21.6 12c0-2.54608-1.0114-4.98788-2.8118-6.78823C16.9879 3.41142 14.5461 2.39999 12 2.39999c-2.54605 0-4.98785 1.01143-6.7882 2.81178C3.41145 7.01212 2.40002 9.45392 2.40002 12c0 2.5461 1.01143 4.9879 2.81178 6.7882C7.01215 20.5886 9.45395 21.6 12 21.6c2.5461 0 4.9879-1.0114 6.7882-2.8118ZM14.4 8.4c0 .63652-.2529 1.24697-.7029 1.6971-.4501.45-1.0606.7029-1.6971.7029-.6365 0-1.247-.2529-1.6971-.7029C9.85286 9.64697 9.6 9.03652 9.6 8.4s.25286-1.24697.7029-1.69706C10.753 6.25286 11.3635 6 12 6c.6365 0 1.247.25286 1.6971.70294.45.45009.7029 1.06054.7029 1.69706ZM12 13.2c-1.1489-.0002-2.27367.3294-3.2407.9497-.96703.6203-1.73565 1.5052-2.2145 2.5495.67521.7855 1.51233 1.4157 2.45393 1.8474.94161.4316 1.96547.6545 3.00127.6534 1.0358.0011 2.0597-.2218 3.0013-.6534.9416-.4317 1.7787-1.0619 2.4539-1.8474-.4789-1.0443-1.2475-1.9292-2.2145-2.5495-.967-.6203-2.0918-.9499-3.2407-.9497Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M9.17157 7.17157C9.92172 6.42143 10.9391 6 12 6s2.0783.42143 2.8284 1.17157C15.5786 7.92172 16 8.93913 16 10c0 1.0609-.4214 2.0783-1.1716 2.8284C14.0783 13.5786 13.0609 14 12 14c-1.0609 0-2.07828-.4214-2.82843-1.1716C8.42143 12.0783 8 11.0609 8 10c0-1.06087.42143-2.07828 1.17157-2.82843ZM12 8c-.5304 0-1.0391.21071-1.4142.58579C10.2107 8.96086 10 9.46957 10 10c0 .5304.2107 1.0391.5858 1.4142S11.4696 12 12 12c.5304 0 1.0391-.2107 1.4142-.5858S14 10.5304 14 10c0-.53043-.2107-1.03914-.5858-1.41421C13.0391 8.21071 12.5304 8 12 8Z"
            clip-rule="evenodd"
        />
        <path
            fill-rule="evenodd"
            d="M21.2388 15.8268c-.3901.9418-.9212 1.8168-1.5737 2.5955-.0147.0188-.03.0369-.0459.0544-.1743.2051-.3572.4034-.5481.5944-.9286.9286-2.031 1.6651-3.2443 2.1677C14.6136 21.7413 13.3132 22 12 22c-1.3132 0-2.61358-.2587-3.82683-.7612-1.21326-.5026-2.31565-1.2391-3.24424-2.1677-.19095-.191-.37379-.3893-.54814-.5944-.01586-.0175-.03117-.0356-.0459-.0544-.65247-.7787-1.18359-1.6537-1.57369-2.5955C2.25866 14.6136 2 13.3132 2 12c0-2.65216 1.05357-5.1957 2.92893-7.07107C6.8043 3.05357 9.34784 2 12 2c2.6522 0 5.1957 1.05357 7.0711 2.92893C20.9464 6.8043 22 9.34784 22 12c0 1.3132-.2587 2.6136-.7612 3.8268ZM11.9999 17c-1.793-.0027-3.56365.3673-5.19814 1.081.638.5454 1.35888.9879 2.13672 1.3101.97061.402 2.01092.6089 3.06142.6089 1.0506 0 2.0909-.2069 3.0615-.6089.778-.3223 1.4989-.7648 2.137-1.3103C15.4495 17.3167 13.8906 17 11.9999 17ZM12 4c-2.12173 0-4.15656.84285-5.65685 2.34315C4.84285 7.84344 4 9.87827 4 12c0 1.0506.20693 2.0909.60896 3.0615.21353.5155.47988 1.006.794 1.4639C7.45293 15.5202 9.70987 14.9966 12.0008 15c2.3649.0001 4.6044.548 6.5963 1.5252.3141-.4578.5804-.9483.7939-1.4637.4021-.9706.609-2.0109.609-3.0615 0-2.12173-.8429-4.15656-2.3431-5.65685C16.1566 4.84285 14.1217 4 12 4Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
